import React, { useState } from 'react';
import { Box } from '@mui/material';
import ClientsList from '../clients-list';
import ClientAddUpdate from '../client-add-update';
import { EditMode } from '../../../../data/enums';

export default function ClientsView() {

  const [editMode, setEditMode] = useState<EditMode>(EditMode.View);

  return (
    <Box sx={{ width: '100%', height: '100%' }}>

      { (editMode === EditMode.View) &&
        <ClientsList mode={editMode} setEditMode={setEditMode}/> 
      }

      { ( (editMode === EditMode.Add || editMode === EditMode.Edit)) && 
        <ClientAddUpdate mode={editMode} setEditMode={setEditMode}/>
      }

    </Box>
  );
}

